import { ResourceConfigurationModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class ResourceLink extends DomainEntity<ResourceConfigurationModelDto> {
    public static from(dto: ResourceConfigurationModelDto): ResourceLink {
        return new ResourceLink(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get title() {
        return this.dto.title;
    }

    public set title(value: string) {
        this.dto.title = value;
    }

    public get link() {
        return this.dto.link;
    }

    public set link(value: string) {
        this.dto.link = value;
    }

    public get tooltip() {
        return this.dto.tooltip ?? '';
    }

    public set tooltip(value: string) {
        this.dto.tooltip = value;
    }

    public get status() {
        return this.dto.status;
    }

    public set status(value: string) {
        this.dto.status = value;
    }

    public get displayExternalWarning() {
        return this.dto.displayExternalWarning;
    }

    public set displayExternalWarning(value: boolean) {
        this.dto.displayExternalWarning = value;
    }

    public get externalWarningMessage() {
        return this.dto.externalWarningMessage ?? '';
    }

    public set externalWarningMessage(value: string) {
        this.dto.externalWarningMessage = value;
    }

    public get logo() {
        return this.dto.logo ?? '';
    }

    public set logo(value: string) {
        this.dto.logo = value;
    }

    public get sequence() {
        return this.dto.sequence ?? 0;
    }

    public get isActive() {
        return this.dto.status === 'Active';
    }
}
